import React from 'react';
import Styled from 'styled-components';
import {
  Headline,
  ModalCtaButton,
} from '@amount/frontend-components';

import {
  ModalHeadline
} from '../../../../Common/CommonStyles/';
import Modal, { IModalProps } from '../../../../Common/Modal';

interface IBasicErrorModalProps extends IModalProps {
  headline: string | JSX.Element;
  message: string | JSX.Element;
}

const ErrorMessage = Styled.h3`
  color: ${({ theme: { text } }) => text.colorText};
`;

export const BasicErrorModal: React.FunctionComponent<IBasicErrorModalProps> = props => (
  <Modal show={props.show} close={props.close} aria-labelledby='error-modal-header'>
    <Headline
      id='error-modal-header'
      scale='medium'
      as='h2'
    >
      We're sorry.
    </Headline>
    <ModalHeadline
      scale='medium'
      as='h2'
    >
      {props.headline}
    </ModalHeadline>
    <ErrorMessage>
      {props.message}
    </ErrorMessage>
    <ModalCtaButton onClick={props.close} inline={true}>
      Return
    </ModalCtaButton>
  </Modal>
);
